module.exports = __webpack_public_path__ + "img/point.2bb224f0.png";